import {
  MenuContentType,
  MenuTreeHierarchyItem,
  MenuTreeHierarchyProduct,
  OrderFormat,
} from '@ancon/wildcat-types'
import getOutletMenuProductsSortCriteria from '@ancon/wildcat-utils/outlet/getOutletMenuProductsSortCriteria'
import orderBy from 'lodash/orderBy'

import { MenuSection } from '../types'

export default function getMenuTreeSections(
  menuGroups: MenuTreeHierarchyItem[],
  menuOrderFormat: OrderFormat,
  showProductsFromOtherOrderFormats: boolean = false,
) {
  const productsSortCriteria = getOutletMenuProductsSortCriteria({
    menuOrderFormat,
    showProductsFromOtherOrderFormats,
  })

  function getMenuSortedProductIds(products: Array<MenuTreeHierarchyProduct>) {
    return orderBy(
      products,
      productsSortCriteria.iteratee,
      productsSortCriteria.orders,
    ).map(product => product.productId)
  }

  return menuGroups.reduce((acc, menuGroup) => {
    if (menuGroup.contentType === MenuContentType.SubMenu) {
      acc.push({
        id: menuGroup.id,
        name: menuGroup.name,
        subGroups: menuGroup.items
          .sort((a, b) => a.sortOrder - b.sortOrder)
          .map(menuItem => ({
            id: menuItem.id,
            name: menuItem.name,
            products: getMenuSortedProductIds(menuItem.items),
          })),
      })
    } else if (menuGroup.contentType === MenuContentType.Product) {
      acc.push({
        id: menuGroup.id,
        name: menuGroup.name,
        products: getMenuSortedProductIds(menuGroup.items),
      })
    }

    return acc
  }, [] as MenuSection[])
}
